import type { ValueOf } from '@vy/utils';

export const INVOICES_PAGE_CSV_HEADERS = Object.freeze({
  STATUS: 'Billing Status',
  DATE: 'Date',
  REVIEW_STATUS: 'Review status',
  ISSUE_DATE: 'Issue date',
  INVOICE_NUMBER: 'Invoice number',
  AMOUNT: 'Amount',
  CURRENCY: 'Currency',
  CUSTOMER: 'Customer',
  CONTRACT: 'Contract',
  CUSTOMER_EXTERNAL_ID: 'External ID',
  CUSTOMER_ERP_ID: 'ERP ID',
  CUSTOMER_CRM_ID: 'CRM ID',
  INVOICE_NOTE: 'Note',
  PAYMENT_DATE: 'Payment date',
  TRANSACTION_ID: 'Transaction ID',
  LAST_SENT_AT: 'Last sent',
  MARKETPLACE_UNITS: 'marketplaceUnits',
  MARKETPLACE_SYNC: 'marketplaceSync',
  MARKETPLACE_RAW_RESPONSE: 'MP Raw Response',
});

export type InvoicesPageCsvHeaders = ValueOf<typeof INVOICES_PAGE_CSV_HEADERS>;
